import React from "react";

const InputTextSimple = ({
  placeholder,
  onChange,
  id,
  name,
  value,
  error,
  disabled = false,
  readOnly = false,
  variant = "light",
}) => {
  return (
    <>
      <div>
        <input
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          disabled={disabled}
          className={`border-[1px] rounded-[0.3rem] transition-all
        ease-in-out duration-100 placeholder-text-seondary-color
         text-text-primary-color focus:border-[#aaaaaa] outline-0 
         font-lato text-[1rem] w-full  ${
           variant === "light" ? "font-normal" : "font-bold "
         } leading-normal  py-[1rem] px-[1.4rem]`}
          placeholder={placeholder}
        />
        <div className="h-2">
          <label
            htmlFor={id}
            className="font-normal text-[0.75rem]  text-red-500 bg-white  my-0 py-0 font"
          >
            {error}
          </label>
        </div>
      </div>
    </>
  );
};

export default InputTextSimple;
